module.exports = __webpack_public_path__ + "static/media/eNPSImage.645b57cd.svg";